/**
 * Cross-cutting feature flags for opt-in refactors.
 *
 * Flags here should default to OFF in environments where they're not explicitly
 * set, so production stays on the legacy code path until the flag flips.
 */

const flag = (raw: string | undefined): boolean =>
  raw === 'true' || raw === '1' || raw === 'on';

/**
 * Space-scoped entity loading.
 *
 * When ON:
 *   - App.tsx skips the legacy dataspace-wide entity bootstrap on non-space routes.
 *   - SpacePageWrapper hydrates per-space caches via spaceEntityStore.initializeSpace().
 *   - Sidebar / Cmd+K / app stores read from space-scoped + Y.Doc-backed selectors.
 *
 * When OFF: legacy useEntityStore behaviour is preserved end-to-end.
 *
 * See plans/entity_loading_refactor_8ae93a18.plan.md.
 */
export const SPACE_SCOPED_ENTITIES = flag(
  (import.meta as any).env?.VITE_SPACE_SCOPED_ENTITIES,
);
